export default __webpack_public_path__ + "static/media/avatar4.992543e1.png";